import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'
import { integrationsClient } from '../../../utils/apollo/api'

const QUERY = gql`
  query omieCurrentAccounts($integrationId: Int, $page: Int) {
    omieCurrentAccounts(integrationId: $integrationId, page: $page, limit: 30) {
      descricao
      nCodCC
      inativo
      codigoBanco
      codigoAgencia
      numeroContaCorrente
    }
  }
`

export const useCurrentAccountSelectLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: integrationsClient })

  return (search, page = 1) => {
    return query({ search, page, ...filter })
      ?.then(pathOr([], ['data', 'omieCurrentAccounts']))
      .then(data => {
        const filteredData = data?.filter(item => item?.inativo === 'N')
        const result = filteredData.map((item, index) => {
          return {
            id: index,
            name: item.descricao,
            nCodCC: item.nCodCC,
            description:
              item?.codigoAgencia &&
              item?.numeroContaCorrente &&
              `Ag: ${item?.codigoAgencia} / CC: ${item?.numeroContaCorrente}`
          }
        })

        return result
      })
  }
}

const CurrentAccountSelect = ({ onChange, value, filter, ...props }) => {
  const getOptions = useCurrentAccountSelectLoader(filter)

  return <Select value={value} onChange={onChange} options={getOptions} {...props} />
}

export default CurrentAccountSelect
